<template>
  <div class="book-list-page">
    <headers :title="title"></headers>
    <van-tabs @change="onTabChange">
      <van-tab v-for="(item, index) in attrclassify"
               :key="index"
               :title="item.title"></van-tab>
    </van-tabs>
    <div class="slider-tab"
         v-show="s_tabs.length">
      <span :class="{'active': s_active == index}"
            v-for="(item, index) in s_tabs"
            :key="index"
            @click="changeTab(index)">{{item.name}}</span>
    </div>
    <!-- <div class="type-scope">
      <p @click="setSort(1)"
         :class="{'p1':active==1}">按时间</p>
      <p @click="setSort(2)"
         :class="{'p1':active==2}">按热度</p>
      <p class="content"
         @click="setSort(3)"
         :class="active==3 && up ? 'p2': active==3 && !up ? 'p3' : 'content'">按价格</p>
    </div> -->
    <Empty v-if="!book_list.length"
           :empty_type="{name: '暂无图书'}"></Empty>
    <List ref="list"
          :url="`/api/app/book/list/${classify_id}`"
          method="get"
          :params="params"
          :on-getdata="onGetdata"
          :showText="book_list.length > 0">
      <div slot="item"
           class="book-list">
        <div class="bl-item"
             v-for="(book,index) in book_list"
             :key="index"
             @click="goBook(book.id)">
          <img class="bli-cover"
               :src="book.cover_img"
               alt />
          <div>
            <div>
              <p class="bli-title">
                <span class="tuan-icon"
                      v-if="book.is_spell"></span>
                <span class="quan-icon"
                      v-if="book.is_has_coupon"></span>
                <font>{{book.name}}</font>
              </p>
              <p class="bli-author">作者：{{book.author}}</p>
              <p class="bli-stock">{{book.sales_base+book.sales_num}}人已购买 &nbsp;&nbsp;|&nbsp;&nbsp; 剩余库存：{{book.stock}} </p>
            </div>
          <!-- 拼团的图书价格显示拼团价 -->
            <p class="bli-price" v-if="book.is_spell">
              <icon-price v-if="book.spell_price"
                          :priceType="2"></icon-price>
              <span v-if="book.spell_price">{{book.spell_price | toFixPrice}}</span>
              <icon-price v-if="book.underlined_price"
                          :priceType="2"></icon-price>
              <span class="under-line"
                    v-if="book.underlined_price">{{book.underlined_price | toFixPrice}}</span>
            </p>
            <p class="bli-price" v-else>
              <icon-price v-if="book.price"
                          :priceType="2"></icon-price>
              <span v-if="book.price">{{book.price | toFixPrice}}</span>
              <span v-else
                    class="is_free">免费</span>
              <icon-price v-if="book.underlined_price"
                          :priceType="2"></icon-price>
              <span class="under-line"
                    v-if="book.underlined_price">{{book.underlined_price | toFixPrice}}</span>
            </p>
          </div>
        </div>
      </div>
    </List>
  </div>
</template>

<script>
import headers from "@/components/Header.vue";
import List from "@/components/List";
import Empty from "@/components/Empty";
export default {
  name: "BookList",
  components: {
    headers,
    List,
    Empty
  },
  data () {
    return {
      title: {
        name: "图书列表"
      },
      tabs: [],
      s_tabs: [],
      active: 1,
      up: true,
      book_list: [],
      id: 0,
      classify_id: this.$store.state.personInfo.classify_id || localStorage.classify_id,
      params: {
        order: "id",
        sort: ""
      },
      s_active: 0,
      tab_index: 0,
      up: 0,
      attrclassify: []
    };
  },
  created () {
    // this.params.classify_id = this.classify_id;
    // this.getTabs();
    this.getClassify();
  },
  methods: {
    getClassify () {
      let param = { classify_id: this.classify_id };
      this.$pub.getClassify(param).then(res => {
        if (res.length > 0) {
          this.attrclassify = res;
          this.attrclassify.unshift({ id: this.classify_id, title: '全部' });
        }
      })
    },
    onGetdata (data) {
      this.book_list = data;
    },
    onTabChange (index) {
      // this.id = this.tabs[index].id;
      // if (this.tabs[index].child) {
      //   this.s_tabs = this.tabs[index].child;
      //   this.s_active = 0;
      // } else {
      //   this.s_tabs = [];
      // }
      // this.tab_index = index;
      this.classify_id = this.attrclassify[index].id;
      this.$refs.list.reset();
    },
    changeTab (index) {
      if (this.s_tabs[index].id == 0) {
        this.id = this.tabs[this.tab_index].id;
      } else {
        this.id = this.s_tabs[index].id;
      }
      this.s_active = index;
      this.$refs.list.reset();
    },
    async getTabs () {
      this.tabs = await this.$http.get("/api/app/book/classify");
    },
    setSort (val) {
      switch (val) {
        case 1:
          this.active = 1;
          this.params.order = "id";
          break;
        case 2:
          this.active = 2;
          this.params.order = "hot";
          break;
        default:
          this.active = 3;
          this.params.order = "price";
          if (this.up) {
            this.up = 0;
            this.params.sort = "desc";
          } else {
            this.up = 1;
            this.params.sort = "asc";
          }
          break;
      }
      this.$refs.list.reset();
    },
    setPrice () {
      if (this.active == 3) {
        this.up = !this.up;
      } else {
        this.active = 3;
      }
    },
    goBook (id) {
      this.$router.push({
        name: "BookDetail",
        query: {
          id
        }
      });
    }
  }
};
</script>

<style lang='scss' scoped>
.book-list-page {
  @extend %default-bg;
  .slider-tab {
    display: flex;
    overflow-x: scroll;
    background: #fff;
    padding-top: 30px;
    span {
      flex: none;
      padding: 0 30px;
      height: 46px;
      background: rgba(237, 237, 237, 1);
      border-radius: 23px;
      margin-left: 30px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(89, 89, 89, 1);
      line-height: 46px;
      text-align: center;
    }
    .active {
      color: $theme_color;
    }
  }
  .type-scope {
    display: flex;
    padding-top: 10px;
    background: #fff;
    p {
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(89, 89, 89, 1);
      width: 150px;
      text-align: center;
      line-height: 80px;
    }
    .content {
      position: relative;
      &::before {
        content: "";
        position: absolute;
        right: 10px;
        top: 50%;
        margin-top: -12px;
        width: 14px;
        height: 24px;
        background: url("~@/assets/images/book/price-order.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .p1 {
      color: $theme_color;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        width: 48px;
        height: 4px;
        margin-left: -24px;
        left: 50%;
        bottom: 0;
        background: $theme_color;
      }
    }
    .p2 {
      color: $theme_color;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        width: 48px;
        height: 4px;
        margin-left: -24px;
        left: 50%;
        bottom: 0;
        background: $theme_color;
      }
      &::before {
        content: "";
        position: absolute;
        right: 10px;
        top: 50%;
        margin-top: -12px;
        width: 14px;
        height: 24px;
        background: url("~@/assets/images/book/up.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .p3 {
      color: $theme_color;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        width: 48px;
        height: 4px;
        margin-left: -24px;
        left: 50%;
        bottom: 0;
        background: $theme_color;
      }
      &::before {
        content: "";
        position: absolute;
        right: 10px;
        top: 50%;
        margin-top: -12px;
        width: 14px;
        height: 24px;
        background: url("~@/assets/images/book/down.png") no-repeat;
        background-size: 100% 100%;
      }
    }
  }
  .book-list {
    margin-top: 30px;
    // padding: 30px;
    .bl-item {
      height: 300px;
      background: rgba(255, 255, 255, 1);
      // box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.07);
      // border-radius: 12px;
      display: flex;
      padding-left: 30px;
      padding-bottom: 30px;
      &:last-child {
        margin: 0;
      }
      .bli-cover {
        width: 180px;
        height: 240px;
        margin-top: 30px;
        margin-right: 30px;
        flex: none;
      }
      > div {
        height: 280px;
        margin-top: 30px;
        width: 480px;
        border-bottom: 1px solid #f6f6f6;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        position: relative;
        .bli-title {
          // margin-top: 30px;
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333;
          line-height: 40px;
          max-height: 80px;
          overflow: hidden;
          .quan-icon,.tuan-icon {
            width: 35px;
            height: 35px;
            background: url("~@/assets/images/quan@2x.png") no-repeat;
            background-size: 100% 100%;
            margin-right: 10px;
            display: inline-block;
            vertical-align: middle;
          }
          .tuan-icon {
            background: url("~@/assets/images/tuan@2x.png") no-repeat;
            background-size: 100% 100%;
          }
        }
        .bli-author {
          margin-top: 20px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999;
          line-height: 40px;
        }
        .bli-stock {
          font-size: 24px;
          color: #999;
          margin-top: 24px;
        }
        .bli-price {
          position: absolute;
          bottom: 10px;
          span {
            margin-right: 10px;
          }
          /deep/ .price-ico {
            width: 16px;
            margin: 0 4px;
          }
          .under-line {
            font-size: 24px;
            color: #979797;
            text-decoration: line-through;
          }
          .is_free {
            color: #65ae58;
          }
          font-size: 32px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(238, 31, 31, 1);
          line-height: 32px;
          padding-bottom: 30px;
        }
      }
    }
    & > div:last-child {
      & > div {
        border: none;
      }
    }
  }
}
</style>
